import { useEffect, useState } from 'react';
import cn from 'classnames';
import SVG from '@svg/chevron-up.svg';
import { NUMBERS } from './numbers';

const ScrollToTop = ({ onClick = () => {} }) => {
  const [isVisible, setIsVisible] = useState(false);

  // check if the scroll to top button should be visible by checking if the page has been scrolled to the
  // position of the navbar by checking if the distance scrolled has reached the start of the
  // navbar wich is after 90% of the innerHeight of the display
  const handleScroll = () => {
    const offset = window.scrollY;
    const displayHeight = window.innerHeight;
    const windowHeight = (displayHeight * NUMBERS.TEN) / NUMBERS.ONEHUNDRED;
    if (offset < windowHeight) {
      return setIsVisible(false);
    }
    return setIsVisible(true);
  };

  const handleRedirect = () => {
    onClick();
    window.scrollTo(NUMBERS.ZERO, NUMBERS.ZERO);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="snf-lx-components-servizi-soluzioni-scroll-to-top-scroll-to-top"
      style={{ display: 'contents' }}
    >
      <>
        <div
          className={cn('row justify-content-center arrowContainer', {
            visible: isVisible
          })}
        >
          <div className={cn('col-auto snf-text-color-denim cursor')}>
            <SVG onClick={handleRedirect} />
          </div>
        </div>
      </>
    </div>
  );
};

ScrollToTop.displayName = 'Scroll To Top';
export { ScrollToTop };
